module.exports = __webpack_public_path__ + "static/media/project-boomers.3b58667b.png";